import React from "react";

export const TranslateLang: React.FC<any> = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      fill="none"
      version="1.1"
      width="11.95715045928955"
      height="8.707099914550781"
      viewBox="0 0 11.95715045928955 8.707099914550781"
      {...props}
    >
      <g>
        <path
          d="M10.0429,3.85358L6.8965,0.707105L7.6036,0L11.9572,4.35356L7.6036,8.7071L6.8965,8L10.0429,4.85357L0,4.85357L0,3.85358L10.0429,3.85358Z"
          fill="currentColor"
          fill-opacity="0.44999998807907104"
        />
      </g>
    </svg>
  );
};
